// removed by extract-text-webpack-plugin
module.exports = {"billingHeaderFont":"billingHeaderFont___1pSC4","vpPaymentInfoHeader":"vpPaymentInfoHeader___1xbt-","billingFont":"billingFont___gws_i","vpBillingHistoryItem":"vpBillingHistoryItem___2jjA3","vpBillingHistoryWrapper":"vpBillingHistoryWrapper___Vwy9c","vpBillingHistoryActionField":"vpBillingHistoryActionField___38yF3","vpBillingHistoryTable":"vpBillingHistoryTable___eUQF4"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpBillingHistory.module.less
// module id = 3074
// module chunks = 29